import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import Lib from 'library'
import Native from 'library/native'
import { useNavigate } from 'react-router-dom';
import Switch2 from '../../components/Switch2'
import Global from 'library/Global';

const JoinSuccess = () => {

	const App = useApp()
	const navigate = useNavigate()
	const [useBio, setUseBio] = useState(false)
	const [showLayer, setShowLayer] = useState(false)

	const isIos = App.device?.os.toLowerCase() === "ios";
	const bioText = isIos ? "Face Id로" : "지문으로"

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const onConnect = () => {
		App.setDidRun(true)
		navigate("/")
	}

	const onMain = () => {
		App.setDidRun(true)
		navigate("/home")
	}

	const bioInit = t => {

		Lib.post("/api/mb/join/upd/bio", {
			bioAuthUseYn: t ? "Y" : "N",
			mbId: window.localStorage.getItem("mbId")
		}, data => {
			if (data) {
				window.localStorage.setItem("useBio", t)
				setUseBio(t);
			}
		})
	}

	const setBioInfo = (t) => {

		if (!useBio) {

			Native.execute("AppManager", "setAuthenticate", result => {
				const json = JSON.parse(result)

				if (json.result === "Success") {
					bioInit(!useBio)
				} else {
					console.error(decodeURI(json.result))
				}
			}, { userid: window.localStorage.getItem("mbId") })
		} else {
			bioInit(!useBio)
		}
/*				
		Lib.post(`/api/mb/join/upd/bio`, {
			bioAuthUseYn: t ? "Y" : "N",
		}, data => {
			console.log('t : ' + t);
			console.log('data : ' + data);
			console.log('useBio : ' + window.localStorage.getItem("useBio"));

			if (data) {
				window.localStorage.setItem("useBio", t)
			}	
			if (t && data) {

				Native.execute("AppManager", "setAuthenticate", result => {
					console.log('result : ' + result)
					const json = JSON.parse(result)
					if (json.result !== "Success") {
						console.error(decodeURI(json.result))
					}
				}, { userid: App.user.mbId })				
			}
		})
*/		
	}
/*
	useEffect(() => {
		setBioInfo(useBio)
	}, [useBio])
*/
	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_smile" />
				<h3 className="intro-tit mt_30">회원가입이 완료되었어요.</h3>
			</div>
			<div className="flex-shrink_0 padding">
				<div className={styles["join-box"]}>
					<p className={styles.title}>생체 인증 로그인 사용</p>
					<span className="mt_10">다음 로그인 시 생체 인증 로그인을 통해 쉽고<br /> 빠르게 접속이 가능해요.</span>
					<hr className="my_20" />
					<div className="flex-justify_between align_center">
						<p className={styles.title}>{bioText} 로그인</p>
						<Switch2 on={useBio} onToggle={setBioInfo} /> 
					</div>
				</div>

				<div className="flex-shrink_0 mt_20 btn-group flex-full">
					<Button className="btn btn--big btn--gray" onClick={onConnect}>메인으로 가기</Button>
					<Button className="btn btn--big ml_10" onClick={onMain}>마이데이터 연결</Button>
				</div>
			</div>

			<ConfirmLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div className="layer-text">
				회원정보가 없어요.<br />
				입력하신 정보를 다시한번 확인해주세요.
			</div>
		</LayerBottom>
	)
}

export default JoinSuccess